import React from 'react';
import { CheckIcon, PlusIcon } from 'lucide-react';
import { useFunnel } from '../../contexts/FunnelContext';
import { labelForKey, suggestedInventory } from '../../data/inventory';

/** Proposed items the customer chooses. Tapping adds the suggested quantity; nothing is added automatically. */
export function SuggestedItems({
  roomItemIds
}: {
  roomItemIds?: string[];
}) {
  const {
    t,
    lang,
    data,
    update
  } = useFunnel();
  if (!data.bedrooms || data.homeType === 'office') return null;
  const suggested = Object.entries(suggestedInventory[data.bedrooms]).filter(([key]) => !roomItemIds || roomItemIds.includes(key.split(':')[0]));
  if (!suggested.length) return null;
  const pending = suggested.filter(([key]) => !(data.inventory[key] > 0));
  const add = (pairs: [string, number][]) => {
    const next = {
      ...data.inventory
    };
    for (const [key, q] of pairs) if (!(next[key] > 0)) next[key] = q;
    update({
      inventory: next
    });
  };
  return <div data-id="element-1006" data-mp="2pdhc4rgsvtwz">
      <p className="mb-2 text-xs font-medium text-ink-500" data-id="element-1007" data-mp="2pdr24f1ui12o">{t('suggested')}</p>
      <div className="flex flex-wrap gap-2" data-id="element-1008" data-mp="3nizkihyw6s6m">
        {suggested.map(([key, qty]) => {
        const on = data.inventory[key] > 0;
        return <button key={key} type="button" disabled={on} onClick={() => add([[key, qty]])} className={`inline-flex min-h-[40px] items-center gap-1.5 rounded-full border px-3 text-sm font-medium transition-[background-color,border-color] duration-150 ease-out ${on ? 'border-ink bg-ink text-white' : 'border-dashed border-ink-400 bg-white text-ink hover:border-ink'}`} data-id="element-1009" data-mp="3eke5gwsmpval">
              {on ? <CheckIcon className="h-3.5 w-3.5 text-lime" aria-hidden="true" data-id="element-1010" data-mp="5e632e6i0b8q" /> : <PlusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1011" data-mp="5cbgywjhqd32" />}
              {labelForKey(key, lang)} {qty > 1 ? `× ${qty}` : ''}
              <span className="sr-only" data-id="element-1012" data-mp="xv8jhb5guqy8">{on ? t('added') : t('suggested')}</span>
            </button>;
      })}
      </div>
      {pending.length > 1 && <button type="button" onClick={() => add(pending)} className="mt-3 min-h-[44px] text-sm font-semibold text-ink underline decoration-ink-300 underline-offset-4 hover:decoration-ink" data-id="element-1013" data-mp="13pdsiztky5uv">
          {roomItemIds ? t('addSuggestedRoom') : t('addAll')}
        </button>}
    </div>;
}